import { AzioniIstanzaSezioneDati } from '@framework/api-client';
import {
  IEngineSection,
  IRootWidget,
  mapToEngineSection,
} from '@framework/engine';
import { DeclarationActionLogic } from '../../../declaration/actions/DeclarationActionLogic';

export function mapDeclarationSections(
  input: AzioniIstanzaSezioneDati[] | null | undefined,
): IEngineSection[] {
  if (!input) return [];

  const sections = input
    .map(declaration => {
      if (
        !declaration.sezioneDati?.idSezioneDati ||
        !declaration.sezioneDati.jsonCampi
      ) {
        return null;
      }

      const root = declaration.sezioneDati.jsonCampi as IRootWidget;
      const id = declaration.sezioneDati.idSezioneDati;

      const isEditable = DeclarationActionLogic.isDeclarationEditable(
        declaration.azioni,
      );

      return mapToEngineSection({
        id,
        elementi: root,
        sectionRootScope: {
          isReadonly: !isEditable,
        },
      });
    })
    .filter(Boolean) as IEngineSection[];

  return sections;
}
